<template>
    <section v-if="reportData.hasOwnProperty('report')" class="p-5 card log-panel col-xl-8 offset-xl-2 col-10 offset-1  my-3">
        <div class="row">
            <div class="table-responsive">
                <!-- <h2 class="text-center label">{{departs.find(e => e.id === reportData.departId)?.name}}</h2> -->
                <h2 class="text-center label">{{depart}}</h2>
                <!--  -->
                <table v-if="reportData.hasOwnProperty('report')" class="main-table table table-bordered">
                    <thead>
                        <tr>
                            <th>رقم الإيصال</th>
                            <th>رقم التسجيل </th>
                            <th>اسم المتقدم</th>
                            <th>رقم الهاتف</th>
                            <th>رقم الجواز</th>
                            <th>نوع المركبة</th>
                            <th>قيمة الإيصال</th>
                            <th>نوع الطلب</th>
                            <th>حالة الطلب</th>
                            <th>تاريخ الإيصال</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(applicant, i) in reportData.report" :key="i" class="bg-blink">
                            <td>{{ applicant.receiptNo }}</td>
                            <td>
                                <router-link class="nav-link" :to="'/admin/applicant/' + applicant.id">{{
                                    applicant.id}}</router-link>
                            </td>
                            <td>
                                <router-link class="nav-link" :to="'/admin/applicant/' + applicant.id">{{
                                    applicant.applicantName }}</router-link>
                            </td>
                            <td>{{ applicant.phoneNo }}</td>
                            <td>{{ applicant.passNo }}</td>
                            <td>{{ applicant.transMade }}</td>
                            <td>{{ applicant.receiptValue }}</td>
                            <td :title="$appType.title[applicant.appType]">
                                {{ $appType.desc[applicant.appType] }}
                            </td>
                            <td v-if="applicant?.status" :class="$adminAppStatus[applicant.appType][applicant.status]?.class">
                                {{ $adminAppStatus[applicant.appType][applicant.status]?.text }}
                            </td>
                            <td>{{ applicant.oprationDate }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="text-center">
                    <h3>
                        <p class="text-muted">لا توجد نتائج مطابقة.</p>
                    </h3>
                </div>

                <div class="pagination-controls text-center mt-3">
                    <button class="btn btn-primary" :disabled="reportData.pageNo === 1"
                        @click="$parent.changePage(reportData, reportData.pageNo - 1)">
                        السابق
                    </button>
                    <span class="mx-2">الصفحة {{ reportData.pageNo }} من {{ reportData.totalPages }}</span>
                    <button class="btn btn-primary" :disabled="reportData.pageNo === reportData.totalPages"
                        @click="$parent.changePage(reportData, reportData.pageNo + 1)">
                        التالي
                    </button>
                    <span class="mx-3" title="العدد الإجمالي">{{ ($parent.currentCountInView < reportData?.totalResults) ?
                        $parent.currentCountInView : reportData?.totalResults }} من {{ reportData?.totalResults
                            }}</span>
                </div>
                <!--  -->
                <div class="d-flex justify-content-between">
                    <button class="btn btn-primary align-end" @click="$parent.printPdf()">طباعة التقرير <font-awesome-icon
                            :icon="['fas', 'print']" /></button>
                    <div class="d-flex">
                        <h5 class="pe-1">القيمة الإجمالية : </h5>
                       
                        <h5> {{ reportData?.totalIncome.toFixed(2)  }} </h5>
                        
                    </div>
                </div>
                <hr />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ReceiptsReport",
    props: {
        reportData: {
            default: {},
            type: Object
        },
        depart: String,
    }
};
</script>
